if (!customElements.get("age-verification")) {
  class AgeVerification extends HTMLElement {
    constructor() {
      super();
      this.overlay = null;
      this.acceptButton = null;
      this.declineButton = null;
      this.backButton = null;
      this._focusTrap = null;
    this.rememberCheckbox = null;
    this.viewVerification = null;
    this.viewDenied = null;
    this.rememberDays = 30;
    this.showRemember = true;
    this.testMode = false;
    this.storageKey = "";
    this.onAccept = this.onAccept.bind(this);
      this.onDecline = this.onDecline.bind(this);
      this.onBack = this.onBack.bind(this);
    }

    connectedCallback() {
      this.cacheElements();
      this.cacheSettings();
      this.bindEvents();
      this.initState();
      this.initEditorEvents();
    }

    disconnectedCallback() {
      this.unbindEvents();
    }

    cacheElements() {
      this.overlay = this.querySelector("[data-age-overlay]");
      this.acceptButton = this.querySelector("[data-age-accept]");
      this.declineButton = this.querySelector("[data-age-decline]");
      this.backButton = this.querySelector("[data-age-back]");
      this.rememberCheckbox = this.querySelector("[data-age-remember]");
      this.viewVerification = this.querySelector('[data-age-view="verification"]');
      this.viewDenied = this.querySelector('[data-age-view="denied"]');
    }

    cacheSettings() {
    this.rememberDays = Number(this.dataset.rememberDays || 30);
    this.showRemember = this.dataset.showRemember === "true";
    this.testMode = this.dataset.testMode === "true";
    const id = this.getAttribute("id") || "age-verification";
    this.storageKey = `age-verification:${id}`;
    }

    bindEvents() {
      this.acceptButton?.addEventListener("click", this.onAccept);
      this.declineButton?.addEventListener("click", this.onDecline);
      this.backButton?.addEventListener("click", this.onBack);
    }

    unbindEvents() {
      this.acceptButton?.removeEventListener("click", this.onAccept);
      this.declineButton?.removeEventListener("click", this.onDecline);
      this.backButton?.removeEventListener("click", this.onBack);
    }

  initState() {
    if (this.testMode) {
      this.setView("verification");
      this.show();
      return;
    }
    if (this.isVerified()) {
      this.hide();
      return;
    }
      this.setView("verification");
      this.show();
    }

    setView(view) {
      if (view === "denied") {
        this.viewDenied?.classList.remove("hidden");
        this.viewVerification?.classList.add("hidden");
        return;
      }
      this.viewVerification?.classList.remove("hidden");
      this.viewDenied?.classList.add("hidden");
    }

    show() {
      this.classList.remove("hidden");
      this.classList.add("flex");
      this.setAttribute("aria-hidden", "false");
      if (this.overlay) {
        this.overlay.classList.add("opacity-100");
        this.overlay.classList.remove("opacity-0");
      }
      document.documentElement.classList.add("overflow-hidden");
      if (!this._focusTrap) {
        this._focusTrap = webvista.createFocusTrap(this);
      }
      this.addEventListener("keydown", this._focusTrap);
      webvista.focusFirstElement(this);
    }

    hide() {
      if (this.overlay) {
        this.overlay.classList.remove("opacity-100");
        this.overlay.classList.add("opacity-0");
      }
      this.classList.add("hidden");
      this.classList.remove("flex");
      this.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("overflow-hidden");
      if (this._focusTrap) {
        this.removeEventListener("keydown", this._focusTrap);
      }
    }

    onAccept() {
      this.setVerified();
      this.hide();
    }

    onDecline() {
      this.setView("denied");
    }

    onBack() {
      this.setView("verification");
    }

    isVerified() {
      const now = Date.now();
      try {
        const stored = localStorage.getItem(this.storageKey);
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed && parsed.expires && now < parsed.expires) return true;
        }
      } catch (error) {
        // Ignore storage errors.
      }
      try {
        return sessionStorage.getItem(this.storageKey) === "verified";
      } catch (error) {
        return false;
      }
    }

    initEditorEvents() {
      if (!Shopify.designMode) return;
      document.addEventListener("shopify:section:select", (e) => {
        if (e.detail.sectionId !== this.getAttribute("id")?.replace("Age-Verification-", "")) return;
        this.setView("verification");
        this.show();
      });
      document.addEventListener("shopify:section:deselect", (e) => {
        if (e.detail.sectionId !== this.getAttribute("id")?.replace("Age-Verification-", "")) return;
        this.hide();
      });
    }

    setVerified() {
      const remember = this.showRemember && this.rememberCheckbox?.checked;
      if (remember && this.rememberDays > 0) {
        const expires = Date.now() + this.rememberDays * 24 * 60 * 60 * 1000;
        try {
          localStorage.setItem(
            this.storageKey,
            JSON.stringify({ verified: true, expires })
          );
          return;
        } catch (error) {
          // Fallback to session.
        }
      }
      try {
        sessionStorage.setItem(this.storageKey, "verified");
      } catch (error) {
        // No-op
      }
    }
  }

  customElements.define("age-verification", AgeVerification);
}
